import { useQuery } from '@tanstack/react-query';
import EntityAPI from '../services/entity';

export const entityDetailsQueryKey = (entityId: string) => ['entity-details', entityId] as const;

/**
 * Shared entity details fetch — dedupes getEntityDetails across hooks/components.
 */
export function useEntityDetails(entityId: string | undefined | null) {
  return useQuery({
    queryKey: entityDetailsQueryKey(entityId || ''),
    queryFn: () => EntityAPI.getEntityDetails(entityId!),
    staleTime: 5 * 60 * 1000,
    enabled: !!entityId,
  });
}
